import { datadogRum } from "@datadog/browser-rum";
import { TelemetryInstance } from "./Telemetry";
import { WriteKeyMap } from "./utils";
import { ClientOptionsStore } from "~/modules/client/ClientOptions/ClientOptionsStore";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName, Logger } from "~/modules/logger";
import { getEnvironmentConfig } from "~/modules/config";
import { parseRegionForAnalytics } from "~/utils/regionUtil";
import packageInfo from "package.json";

export class TelemetryImpl implements TelemetryInstance {
    private readonly clientOptions: ClientOptionsStore;

    private disabled: boolean = false;

    private readonly logger: Logger;

    constructor(ctx: ContextManager) {
        this.clientOptions = ctx.retrieveInstanceOf(ContextInstance.ClientOptionsStore, ClientOptionsStore);
        this.logger = getLogger(ctx)(LoggerName.Analytics);
    }

    








    public init(telemetryDisabled: boolean, writeKeyMap?: WriteKeyMap, accountSid?: string): void {
        try {
            if (telemetryDisabled) {
                this.disabled = true;
                return;
            }

            const environmentConfig = getEnvironmentConfig();
            const { region } = environmentConfig ?? {};
            const configRegion = region ?? this.clientOptions.region ?? "us1";
            const env = parseRegionForAnalytics(configRegion);
            const applicationId = writeKeyMap?.telemetry?.applicationId;
            const clientToken = writeKeyMap?.telemetry?.clientToken;

            if (!clientToken || !applicationId) {
                this.logger.warn(
                    "FlexSDK Telemetry configuration not found. The FlexSDK Operational Telemetry will be disabled."
                );
                this.disabled = true;
                return;
            }

            const ddUser = datadogRum.getUser();

            if (ddUser?.id) {
                this.logger.warn("FlexSDK Telemetry is already initialized.");
                return;
            }
            datadogRum.init({
                applicationId,
                clientToken,
                env,
                
                
                site: "datadoghq.com",
                service: "flexsdk-js",
                
                version: packageInfo.version,
                sessionSampleRate: 0, 
                sessionReplaySampleRate: 0,
                trackUserInteractions: false,
                defaultPrivacyLevel: "mask-user-input"
            });

            datadogRum.setUser({
                id: accountSid ?? "unknown"
            });
        } catch (e) {
            this.logger.warn("Failed to initialise FlexSDK Telemetry", e);
            this.disabled = true;
        }
    }

    







    track(error: Error, context?: object): void {
        datadogRum.addError(error, {
            source: "flexsdk",
            product: "Flex",
            error: error,
            errorMessage: error?.message ?? "Something went wrong",
            realm: this.clientOptions.region ?? "us1",
            flexSdkVersion: packageInfo.version,
            ...context
        });
    }
}
